"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CONNECTED_STATUS = 'connected';

var FacebookLoginComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(FacebookLoginComponent, _Component);

  function FacebookLoginComponent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FacebookLoginComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FacebookLoginComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_fbInit", function () {
      var forceLogin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props = _this.props,
          appId = _this$props.appId,
          version = _this$props.version,
          cookie = _this$props.cookie,
          xfbml = _this$props.xfbml,
          autoLogin = _this$props.autoLogin; // when forceLogin is true, force getting user information since sdk is already loaded

      if (forceLogin && autoLogin) {
        window.FB.getLoginStatus(_this._checkLoginStatus);
      } else {
        window.fbAsyncInit = function () {
          window.FB.init({
            appId: appId,
            cookie: cookie,
            xfbml: xfbml,
            version: version
          });

          if (autoLogin) {
            window.FB.getLoginStatus(_this._checkLoginStatus);
          }
        };
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_loadSDK", function () {
      var language = _this.props.language;

      (function (doc, tagName, id, fbInit) {
        var element = doc.getElementsByTagName(tagName)[0];
        var fjs = element;
        var js = element;

        if (doc.getElementById(id)) {
          // if the sdk is already loaded, call fbInit anyway and force it to get user information
          if (fbInit) {
            fbInit(true);
          }

          return;
        }

        js = doc.createElement(tagName);
        js.id = id;
        js.src = "https://connect.facebook.net/".concat(language, "/sdk.js#version=v2.0");
        fjs.parentNode.insertBefore(js, fjs);

        if (fbInit) {
          fbInit();
        }
      })(document, 'script', 'facebook-jssdk', _this._fbInit);
    });

    _defineProperty(_assertThisInitialized(_this), "_checkLoginStatus", function (_ref) {
      var status = _ref.status,
          authResponse = _ref.authResponse;
      var _this$props2 = _this.props,
          language = _this$props2.language,
          fields = _this$props2.fields,
          handleOnResponse = _this$props2.handleOnResponse,
          handleOnLoadComplete = _this$props2.handleOnLoadComplete,
          handleOnNotConnected = _this$props2.handleOnNotConnected,
          isLoggedIn = _this$props2.isLoggedIn;

      if (status === CONNECTED_STATUS && authResponse) {
        window.FB.api('/me', {
          locale: language,
          fields: fields
        }, function (me) {
          handleOnResponse(_objectSpread({}, me, {}, authResponse));
        });

        if (isLoggedIn) {
          isLoggedIn();
        }
      } else if (handleOnNotConnected) {
        handleOnNotConnected(status);
      }

      if (handleOnLoadComplete) {
        handleOnLoadComplete();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_facebookLogin", function () {
      var _this$props3 = _this.props,
          scope = _this$props3.scope,
          reRequestPermissions = _this$props3.reRequestPermissions;
      var requestParams = {
        scope: scope
      };

      if (reRequestPermissions) {
        requestParams['auth_type'] = 'rerequest';
      }

      window.FB.login(_this._checkLoginStatus, requestParams);
    });

    return _this;
  }

  _createClass(FacebookLoginComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._loadSDK();
    }
    /**
     * Init FB object and if autoLogin parameter is true check the login status
     */

  }, {
    key: "render",
    value: function render() {
      return this.props.renderProps({
        onClick: this._facebookLogin
      });
    }
  }]);

  return FacebookLoginComponent;
}(_react.Component);

exports.default = FacebookLoginComponent;

_defineProperty(FacebookLoginComponent, "PropTypes", {
  appId: _propTypes.default.string.isRequired,
  version: _propTypes.default.string,
  cookie: _propTypes.default.bool,
  language: _propTypes.default.string,
  fields: _propTypes.default.string,
  handleOnResponse: _propTypes.default.func.isRequired,
  scope: _propTypes.default.string,
  autoLogin: _propTypes.default.bool,
  xfbml: _propTypes.default.bool,
  renderProps: _propTypes.default.func.isRequired,
  handleOnLoadComplete: _propTypes.default.func,
  isLoggedIn: _propTypes.default.func,
  handleOnNotConnected: _propTypes.default.func,
  reRequestPermissions: _propTypes.default.bool
});

_defineProperty(FacebookLoginComponent, "defaultProps", {
  version: 'v2.10',
  cookie: false,
  language: 'en_US',
  fields: 'name,picture,first_name',
  scope: 'public_profile,email',
  autoLogin: true,
  xfbml: false,
  reRequestPermissions: false
});
//# sourceMappingURL=FacebookLoginComponent.js.map